import { facilityColor, fmtDate } from "@/lib/constants";
import { PaymentBadge, BookingStatusBadge } from "@/components/StatusBadges";
import { useBookingDialog } from "@/context/BookingDialogContext";

export const BookingRow = ({ b, facilityName }) => {
  const { openEdit } = useBookingDialog();
  return (
    <button
      type="button"
      onClick={() => openEdit(b)}
      data-testid={`booking-row-${b.id}`}
      className="flex w-full items-center gap-4 px-5 py-3.5 text-left hover:bg-[#FDF2F4]/60 transition-colors"
    >
      <div className="w-14 shrink-0 text-center">
        <div className="font-serif text-2xl font-semibold leading-none text-slate-900">{fmtDate(b.date, "d")}</div>
        <div className="eyebrow mt-1">{fmtDate(b.date, "MMM")}</div>
      </div>
      <span className={`h-10 w-1 shrink-0 rounded-full ${facilityColor(b.facility_slug).dot}`} />
      <div className="min-w-0 flex-1">
        <p className="truncate font-semibold text-slate-900">{b.title}</p>
        <p className="truncate text-xs text-slate-500">
          <span className="font-mono">{b.start_time}–{b.end_time}</span>
          {facilityName && <> · {facilityName}</>} · {b.applicant_name}
        </p>
      </div>
      <div className="hidden sm:flex flex-col items-end gap-1">
        <PaymentBadge status={b.payment_status} />
        {b.booking_status !== "confermata" && <BookingStatusBadge status={b.booking_status} />}
      </div>
    </button>
  );
};
